// Hide content based on URL parameter
function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var dynamicContent = getParameterByName('participant');
if (dynamicContent == '1') {
    $('.participant-hide').hide();
} else {
    $('.leader-hide').hide();
}

// Tabs for viewing different parts
$('.precept-upon .parts-tabs').tabslet({
    animation: true,
    deeplinking: true
});
$('.in-out .parts-tabs').tabslet({
    animation: true,
    deeplinking: true
});

if ($('.precept-upon .parts-tabs ul li').length > 5) {
    $('.pup--left').removeClass('hidden');
    $('.pup--right').removeClass('hidden');
    $('.precept-upon .parts-tabs ul').addClass('w-5/6');
    $('.precept-upon .parts-tabs ul').slick({
        autoplay: false,
        arrows: true,
        fade: false,
        autoplaySpeed: 5000,
        speed: 500,
        infinite: false,
        slidesToShow: 5,
        prevArrow: $('.pup--left'),
        nextArrow: $('.pup--right')
    });
}

if ($('.in-out .parts-tabs ul li').length > 5) {
    $('.pio--left').removeClass('hidden');
    $('.pio--right').removeClass('hidden');
    $('.in-out .parts-tabs ul').addClass('w-5/6');
    $('.in-out .parts-tabs ul').slick({
        autoplay: false,
        arrows: true,
        fade: false,
        autoplaySpeed: 5000,
        speed: 500,
        infinite: false,
        slidesToShow: 5,
        prevArrow: $('.pio--left'),
        nextArrow: $('.pio--right')
    });
}

// Switch view based on click in sidebar

$('#precept-upon-btn').on('click', function(e) {
    let hash = window.location.hash;
    if(hash.includes('pio-tab')) {
        $('a[href="'+hash.replace('pio', 'pup')+'"]').delay(200).click();
        e.preventDefault();
    }
    $('.in-out').hide();
    $('.precept-upon').show();
    $('.precept-upon .part-type').text('Precept Upon Precept');
    $(this).removeClass('text-gray-500');
    $(this).addClass('bg-charcoal text-white');
    $('.pup-intro').removeClass('text-gray-500');
    $('#in-out-btn').removeClass('bg-charcoal text-white');
    $('#in-out-btn').addClass('text-gray-500 border');
    $('.pio-intro').addClass('text-gray-500');
});

$('#in-out-btn').on('click', function(e) {
    let hash = window.location.hash;
    if(hash.includes('pup-tab')) {
        $('a[href="'+hash.replace('pup', 'pio')+'"]').delay(200).click();
        e.preventDefault();
    }
    $('.in-out').removeClass('h-0');
    $('.in-out').show();
    $('.precept-upon').hide();
    $('.in-out .part-type').text('In & Out');
    $(this).removeClass('text-gray-500');
    $(this).addClass('bg-charcoal text-white');
    $('.pio-intro').removeClass('text-gray-500');
    $('#precept-upon-btn').removeClass('bg-charcoal text-white');
    $('#precept-upon-btn').addClass('text-gray-500 border');
    $('.pup-intro').addClass('text-gray-500');
});

var studySelected = window.location.hash;

if(studySelected.includes('pio')) {
    $('#in-out-btn').click();
}